import { observer } from 'mobx-react-lite'
import { type SingleSelectFilter } from '@/infra/SingleSelectFilter'
import { match } from '@/utils/pattern-match-util'
import type {
  WorkspacePostingStatusFilter,
  WorkspacePostingStatusFilterOption,
} from '@/features/admin/staffing/StaffingSearchViewModel'
import {
  StatusFilterCards,
  type StatusFilterCardTone,
} from '@/features/admin/components/StatusFilterCards'

export interface WorkspacePostingStatusFilterContainerProps<
  TFilters extends Record<string, unknown>,
> {
  filter: SingleSelectFilter<keyof TFilters, WorkspacePostingStatusFilter>
}

export const WorkspacePostingStatusFilterContainer = observer(
  function WorkspacePostingStatusFilterContainer<
    TFilters extends Record<string, unknown>,
  >({ filter }: WorkspacePostingStatusFilterContainerProps<TFilters>) {
    return (
      <StatusFilterCards
        title={filter.title}
        selectedKey={filter.value.type}
        options={filter.options.map((opt) => ({
          key: opt.value.type,
          title: opt.title,
          count: opt.value.count,
          tone: statusTone(opt.value.type),
          onSelect: () => filter.change(opt.value),
        }))}
      />
    )
  },
)

function statusTone(
  type: WorkspacePostingStatusFilterOption,
): StatusFilterCardTone {
  return match<WorkspacePostingStatusFilterOption, StatusFilterCardTone>(type, {
    all: 'Blue',
    draft: 'Red',
    active: 'Green',
    inReview: 'Blue',
    closed: 'Grey',
  })
}
